import { createFeatureSelector } from '@ngrx/store';

export const locationsState = createFeatureSelector<OLO.State, OLO.State.Locations>('locations');
